// @flow

import React from "react";

import { MultiSelect } from "src/components/Unifize";

type Props = {
  value: Array<string>,
  options: Array<string>,
  onChange: Function,
};

const PickList = ({ value, options, onChange }: Props) => {
  // Create data structure expected by MultiSelect
  // Each option becomes an object with id (the option string itself) and value (display text)
  const optionsData = options.map((option) => ({
    id: option,
    value: option,
  }));

  const handleSelection = (selectedIds: Array<string>) => {
    // For picklist fields, the selected IDs are the actual option values
    onChange(selectedIds);
  };

  return (
    <MultiSelect
      label="Value"
      labelWeight="bold"
      placeholder="Search"
      data={optionsData}
      keys={["id", "value"]}
      selected={value || []}
      onChange={handleSelection}
      showSelectAll
      showCheckBox
    />
  );
};

export default PickList;
